import { AxiosError, AxiosResponse } from "axios";
import { IBodyAddSkill, IDeleteSkillBody } from "../../interfaces/ISkills";
import protheusProvider from "../providers/protheus.provider";

export class SkillsService {
  public async getProduct(token: string | null): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTAXS/products', {
        params: {
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getGroups(token: string | null, father: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTAXS/groups', {
        params: {
          token,
          father
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getSkills(token: string | null, father: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTAXS/skills', {
        params: {
          token,
          father
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getProductSearch(token: string | null): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTSKILL', {
        params: {
          token,
          filter: `tipo = '1'`
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getGroupsSearch(token: string | null, code: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTSKILL', {
        params: {
          token,
          filter: `tipo = '2' and codpai = ${code}`
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getSkillSearch(token: string | null, code: string): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.get('WSRESTSKILL', {
        params: {
          token,
          filter: `tipo = '3' and codpai = ${code}`
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async addProduct(objectParams: IBodyAddSkill): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`WSRESTAXS/products/`, objectParams)
      
      return response;
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async addGroup(objectParams: IBodyAddSkill): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`WSRESTAXS/groups/`, objectParams)
      
      return response
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async addSkill (objectParams: IBodyAddSkill): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.post(`/WSRESTAXS/skills/`, objectParams)
      
      return response
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async updateSkillLevel(objectParams: IBodyAddSkill): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.put(`/WSRESTAXS/skills/`, objectParams)
      
      return response
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async deleteSkill (objectParams: IDeleteSkillBody): Promise<AxiosResponse> {
    try {
      const response = await protheusProvider.delete(`/WSRESTAXS/`, objectParams)
      
      return response
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }


}